module.exports = __webpack_public_path__ + "static/media/github.5f3d6a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/background/github.png
// module id = 54
// module chunks = 0